module.exports = __webpack_public_path__ + "static/img/icon-ens-item4.6f2b34d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon-ens-item4.png
// module id = RCOR
// module chunks = 21